import { put, select, take } from 'redux-saga/effects';
import { SetTimelineLabelWidthAction } from 'actions/monitoringActions';
import { getTimelineLabelWidth } from 'selectors/monitoringSelectors';
import { timelinesRedraw } from 'actions/timelineActions';

//
//  Force a redraw of timelines whenever the timeline label width changes
//  (e.g. at startup or when the language changes)
//
export function* redrawTimelineLabelWidthSaga() {
    let oldWidth = yield select(getTimelineLabelWidth);
    while (true) {
        const action: SetTimelineLabelWidthAction = yield take('SET_TIMELINE_LABEL_WIDTH');
        const newWidth = action.payload;

        if (newWidth !== oldWidth) {
            oldWidth = newWidth;
            yield put(timelinesRedraw());
        }
    }
}



// WEBPACK FOOTER //
// ./src/sagas/monitoring/redrawTimelineLabelWidthSaga.ts